import { Box } from '@mui/material';
import { ReactNode, useMemo } from 'react';

interface CanDisableProps {
  children: ReactNode;
  disabled: boolean;
}

export const CanDisable = ({ children, disabled }: CanDisableProps): JSX.Element => {
  const sxProps = useMemo(() => {
    if (disabled) {
      return {
        disabledStyle: {
          pointerEvents: 'none',
          opacity: '0.5',
        },
      };
    }
    return {};
  }, [disabled]);

  return (
    <Box
      // eslint-disable-next-line no-restricted-syntax
      sx={sxProps.disabledStyle}
      width="100%"
    >
      {children}
    </Box>
  );
};
